import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Home({ color = 'icon.primary', strokeWidth = '1.5', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 22 24' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.7204 6.88246L13.0512 1.69495C11.8474 0.757933 10.1612 0.757933 8.95633
         1.69495L2.28715 6.88246C1.47462 7.51381 1 8.48529 1 9.51456V17.6654C1 19.5072
          2.49278 21 4.33459 21H17.6729C19.5148 21 21.0075 19.5072 21.0075 17.6654V9.51456C21.0075
           8.48529 20.5329 7.51381 19.7204 6.88246Z'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
      />
      <Path
        d='M7.66992 16.5538H14.3391'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Home.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Home
